// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type RecentOrderItemsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RecentOrderItemsInput>;
}>;


export type RecentOrderItemsQuery = { __typename?: 'Query', recentOrderItems: { __typename?: 'RecentOrderItemsPayload', count: number, orderItems: Array<{ __typename?: 'RecentOrderItem', purchaseCount: number, quantity: string, type: Types.CartItemType, participantId: string, orderId: string, orderItemId: string, orderDate: number, material: { __typename?: 'Material', id: string, number: string, product: string, erpType?: Array<string | null> | null, isMarketplace?: boolean | null, name?: string | null, description?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null }, image: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } } }> } };

export type RecentOrderItemFragment = { __typename?: 'RecentOrderItem', purchaseCount: number, quantity: string, type: Types.CartItemType, participantId: string, orderId: string, orderItemId: string, orderDate: number, material: { __typename?: 'Material', id: string, number: string, product: string, erpType?: Array<string | null> | null, isMarketplace?: boolean | null, name?: string | null, description?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null }, image: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } } };

export const RecentOrderItemFragmentDoc = gql`
    fragment RecentOrderItem on RecentOrderItem {
  material {
    id
    number
    product
    erpType
    brand {
      key
      erpKey
      name
    }
    isMarketplace
    name
    image {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
    description
  }
  purchaseCount
  quantity
  type
  participantId
  orderId
  orderItemId
  orderDate
}
    `;
export const RecentOrderItemsDocument = gql`
    query RecentOrderItems($input: RecentOrderItemsInput) {
  recentOrderItems(input: $input) {
    count
    orderItems {
      ...RecentOrderItem
    }
  }
}
    ${RecentOrderItemFragmentDoc}`;
export type RecentOrderItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>, 'query'>;

    export const RecentOrderItemsComponent = (props: RecentOrderItemsComponentProps) => (
      <ApolloReactComponents.Query<RecentOrderItemsQuery, RecentOrderItemsQueryVariables> query={RecentOrderItemsDocument} {...props} />
    );
    

/**
 * __useRecentOrderItemsQuery__
 *
 * To run a query within a React component, call `useRecentOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentOrderItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecentOrderItemsQuery(baseOptions?: Apollo.QueryHookOptions<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>(RecentOrderItemsDocument, options);
      }
export function useRecentOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>(RecentOrderItemsDocument, options);
        }
export function useRecentOrderItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>(RecentOrderItemsDocument, options);
        }
export type RecentOrderItemsQueryHookResult = ReturnType<typeof useRecentOrderItemsQuery>;
export type RecentOrderItemsLazyQueryHookResult = ReturnType<typeof useRecentOrderItemsLazyQuery>;
export type RecentOrderItemsSuspenseQueryHookResult = ReturnType<typeof useRecentOrderItemsSuspenseQuery>;
export type RecentOrderItemsQueryResult = Apollo.QueryResult<RecentOrderItemsQuery, RecentOrderItemsQueryVariables>;